export const groupByCategory = (components) => {
  const grouped = {};
  components.forEach((component) => {
    const category = component.category || "Other";
    if (!grouped[category]) {
      grouped[category] = [];
    }
    grouped[category].push(component);
  });
  return grouped;
};
